var map = {
	"./__mocks__/cobranding": 28098,
	"./__mocks__/cobranding.json": 28098,
	"./__mocks__/dbsDepositsTypes": 69641,
	"./__mocks__/dbsDepositsTypes.json": 69641,
	"./__mocks__/layoutProps": 92824,
	"./__mocks__/layoutProps.json": 92824,
	"./__mocks__/pensionProductsData": 33681,
	"./__mocks__/pensionProductsData.json": 33681,
	"./__mocks__/piaProductInstances": 91678,
	"./__mocks__/piaProductInstances.json": 91678,
	"./__mocks__/pomProductsData": 46194,
	"./__mocks__/pomProductsData.json": 46194,
	"./__mocks__/postboxUnreadCount": 85512,
	"./__mocks__/postboxUnreadCount.json": 85512,
	"./__mocks__/productAccess": 80442,
	"./__mocks__/productAccess.json": 80442,
	"./__mocks__/productsTypes": 20613,
	"./__mocks__/productsTypes.json": 20613,
	"./__mocks__/transactionAccount": 54591,
	"./__mocks__/transactionAccount.json": 54591
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51987;